import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UserProfile from "@/pages/UserProfile";
import RequestTrip from "@/pages/RequestTrip";
import SetPassword from "@/pages/SetPassword";
import AuthLinkError from "@/pages/AuthLinkError";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import WorkingProgress from "@/pages/WorkingProgress";
import ItineraryBuilder from "@/pages/ItineraryBuilder";
import ApprovalRoute from "@/components/ApprovalRoute";
import LoginRouteGuard from "@/components/LoginRouteGuard";

const AppRouter = () => {
  const { loading } = useAuth();

  // Se è in corso il caricamento dell'autenticazione, mostra la schermata di loading
  if (loading) {
    return <></>;
  }

  return (
    <Routes>
      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Protected routes - require authentication and approval */}
      <Route path="/dashboard" element={
        <ApprovalRoute>
          <Dashboard />
        </ApprovalRoute>
      } />

      {/* Protected routes - require authentication and approval */}
      {/* <Route path="/dashboardRequests" element={
        <ApprovalRoute>
          <Dashboard />
        </ApprovalRoute>
      } /> */}

      <Route path="/profile" element={
        <ApprovalRoute>
          <UserProfile />
        </ApprovalRoute>
      } />

      <Route path="/itinerary-builder" element={
        <ApprovalRoute>
          <ItineraryBuilder />
        </ApprovalRoute>
      } />

      {/* Working progress pages */}
      <Route path="/booking" element={
        <ApprovalRoute>
          <WorkingProgress />
        </ApprovalRoute>
      } />
      <Route path="/payments" element={
        <ApprovalRoute>
          <WorkingProgress />
        </ApprovalRoute>
      } />


      {/* Redirect old trips route */}
      <Route path="/trips" element={<Navigate to="/dashboard" replace />} />

      {/* Public routes - no authentication required */}
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/set-password" element={<SetPassword />} />
      <Route path="/auth-link-error" element={<AuthLinkError />} />
      <Route path="/request-trip" element={<RequestTrip />} />

      {/* Login route - redirects if already authenticated */}
      <Route path="/login" element={
        <LoginRouteGuard>
          <Login />
        </LoginRouteGuard>
      } />

      {/* 404 - only show when not loading */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
